/* eslint-disable */

export const ROSTER_TIMELINE = {
  SET_DEFAULT_META: 'SET_DEFAULT_META',
  SET_SERVER_ITEMS: 'ROSTER/SET_SERVER_ITEMS',
  SET_TRAVEL_ITEMS: 'ROSTER/SET_TRAVEL_ITEMS',
  SET_LEAVE_ITEMS: 'ROSTER/SET_LEAVE_ITEMS',
  SET_AVAILABILITY_ITEMS: 'ROSTER/SET_AVAILABILITY_ITEMS',

  CLEAR_LOCAL_ITEMS: 'ROSTER/CLEAR_LOCAL_ITEMS',
  CLEAR_SERVER_ITEMS: 'ROSTER/CLEAR_SERVER_ITEMS',
  CLEAR_TRAVEL_ITEMS: 'ROSTER/CLEAR_TRAVEL_ITEMS',
  CLEAR_LEAVE_ITEMS: 'ROSTER/CLEAR_LEAVE_ITEMS',
  CLEAR_AVAILABILITY_ITEMS: 'ROSTER/CLEAR_AVAILABILITY_ITEMS',

  SELECT_TIMELINE_ACTIVITIES: 'ROSTER/SELECT_TIMELINE_ACTIVITIES',
  ADD_ACTIVITY_TO_TIMELINE: 'ROSTER/ADD_ACTIVITY_TO_TIMELINE',
  DELETE_TIMELINE_ACTIVITIES: 'ROSTER/DELETE_TIMELINE_ACTIVITIES',
  MOVE_ACTIVITIES: 'ROSTER/MOVE_ACTIVITIES',
  RESIZE_ACTIVITIES: 'ROSTER/RESIZE_ACTIVITIES',
  MODIFY_LOCAL_ACTIVITIES: 'ROSTER/MODIFY_LOCAL_ACTIVITIES',
  MODIFY_LOCAL_TRAVEL: 'ROSTER/MODIFY_LOCAL_TRAVEL',
  SWAP_ASSIGNMENTS: 'ROSTER/SWAP_ASSIGNMENTS',

  ADD_BULK_ACTIVITIES: 'ROSTER/ADD_BULK_ACTIVITIES',
  REMOVE_BULK_ACTIVITIES_RANGE: 'ROSTER/REMOVE_BULK_ACTIVITIES_RANGE',

  SET_USER_GROUPS: 'ROSTER/SET_USER_GROUPS',
  SET_ACTIVITY_GROUPS: 'ROSTER/SET_ACTIVITY_GROUPS',
  TOGGLE_GROUP_PIN: 'ROSTER/TOGGLE_GROUP_PIN',
  
  UPDATE_PINNED_ACTIVITIES: 'ROSTER/UPDATE_PINNED_ACTIVITIES', // Sidebar pin
  UPDATE_ASSIGNMENT_ACTION: 'ROSTER/UPDATE_ASSIGNMENT_ACTION',

  COPY_ASSIGNMENTS: 'ROSTER/COPY_ASSIGNMENTS',
  PASTE_ASSIGNMENTS: 'ROSTER/PASTE_ASSIGNMENTS',
  CLEAR_CLIPBOARD: 'ROSTER/CLEAR_CLIPBOARD',
};

export const TEMPLATE_TIMELINE = {
  REQUEST_IN_FLIGHT: 'TEMPLATE_TIMELINE/REQUEST_IN_FLIGHT',

  NEW_TEMPLATE: 'TEMPLATE_TIMELINE/NEW_TEMPLATE',
  LOADED_TEMPLATE_SUCCESS: 'TEMPLATE_TIMELINE/LOADED_TEMPLATE_SUCCESS',
  LOADED_TEMPLATE_FAILURE: 'TEMPLATE_TIMELINE/LOADED_TEMPLATE_FAILURE',

  SAVE_TEMPLATE_SUCCESS: 'TEMPLATE_TIMELINE/SAVE_TEMPLATE_SUCCESS',
  SAVE_TEMPLATE_FAILURE: 'TEMPLATE_TIMELINE/SAVE_TEMPLATE_FAILURE',

  SELECT_TIMELINE_ACTIVITIES: 'TEMPLATE_TIMELINE/SELECT_TIMELINE_ACTIVITIES',
  ADD_ACTIVITY_TO_TIMELINE: 'TEMPLATE_TIMELINE/ADD_ACTIVITY_TO_TIMELINE',
  UPDATE_ACTIVITIES: 'TEMPLATE_TIMELINE/UPDATE_ACTIVITIES',
  DELETE_TIMELINE_ACTIVITY: 'TEMPLATE_TIMELINE/DELETE_TIMELINE_ACTIVITY',
  MOVE_ACTIVITIES: 'TEMPLATE_TIMELINE/MOVE_ACTIVITIES',
  RESIZE_ACTIVITIES: 'TEMPLATE_TIMELINE/RESIZE_ACTIVITIES',
  UPDATE_PINNED_ACTIVITIES: 'TEMPLATE_TIMELINE/UPDATE_PINNED_ACTIVITIES',

  REORDER_GROUP: 'TEMPLATE_TIMELINE/REORDER_GROUP',
  DELETE_ENTIRE_GROUP: 'TEMPLATE_TIMELINE/DELETE_ENTIRE_GROUP'
};

export const TEMPLATE_MAPPER = {
  LOADED_TEMPLATE_SUCCESS: 'TEMPLATE_MAPPER/LOADED_TEMPLATE_SUCCESS',
  LOADING_IN_PROGRESS: 'TEMPLATE_MAPPER/LOADING_IN_PROGRESS',
  LOADING_FAILED: 'TEMPLATE_MAPPER/LOADING_FAILED',

  ASSIGN_USER_TO_PLACEHOLDER: 'TEMPLATE_MAPPER/ASSIGN_USER_TO_PLACEHOLDER',
  REMOVE_ASSIGNED_USER: 'TEMPLATE_MAPPER/REMOVE_ASSIGNED_USER',
  REORDER_ASSIGNED_USER: 'TEMPLATE_MAPPER/REORDER_ASSIGNED_USER',
  SWAP_USER_WITH_PLACEHOLDER: 'TEMPLATE_MAPPER/SWAP_USER_WITH_PLACEHOLDER',

  ADD_ROSTER_EVENT_DETAILS: 'TEMPLATE_MAPPER/ADD_ROSTER_EVENT_DETAILS'
};

export const ROSTERBUILDER_TIMELINE = {
  REQUEST_IN_FLIGHT: 'ROSTERBUILDER_TIMELINE/REQUEST_IN_FLIGHT',

  NEW_ROSTERBUILDER: 'ROSTERBUILDER_TIMELINE/NEW_ROSTERBUILDER',
  LOADED_ROSTERBUILDER_SUCCESS: 'ROSTERBUILDER_TIMELINE/LOADED_ROSTERBUILDER_SUCCESS',
  LOADED_ROSTERBUILDER_FAILURE: 'ROSTERBUILDER_TIMELINE/LOADED_ROSTERBUILDER_FAILURE',

  SAVE_ROSTERBUILDER_SUCCESS: 'ROSTERBUILDER_TIMELINE/SAVE_ROSTERBUILDER_SUCCESS',
  SAVE_ROSTERBUILDER_FAILURE: 'ROSTERBUILDER_TIMELINE/SAVE_ROSTERBUILDER_FAILURE',

  SELECT_TIMELINE_ACTIVITIES: 'ROSTERBUILDER_TIMELINE/SELECT_TIMELINE_ACTIVITIES',
  ADD_ACTIVITY_TO_TIMELINE: 'ROSTERBUILDER_TIMELINE/ADD_ACTIVITY_TO_TIMELINE',
  UPDATE_ACTIVITIES: 'ROSTERBUILDER_TIMELINE/UPDATE_ACTIVITIES',
  DELETE_TIMELINE_ACTIVITY: 'ROSTERBUILDER_TIMELINE/DELETE_TIMELINE_ACTIVITY',
  MOVE_ACTIVITIES: 'ROSTERBUILDER_TIMELINE/MOVE_ACTIVITIES',
  RESIZE_ACTIVITIES: 'ROSTERBUILDER_TIMELINE/RESIZE_ACTIVITIES',
  UPDATE_PINNED_ACTIVITIES: 'ROSTERBUILDER_TIMELINE/UPDATE_PINNED_ACTIVITIES',

  REORDER_GROUP: 'ROSTERBUILDER_TIMELINE/REORDER_GROUP',
  DELETE_ENTIRE_GROUP: 'ROSTERBUILDER_TIMELINE/DELETE_ENTIRE_GROUP',

  // Users
  SET_USERS: 'ROSTERBUILDER_TIMELINE/SET_USERS',
  LOADED_USERS_ROSTERBUILDER_SUCCESS: 'ROSTERBUILDER_TIMELINE/LOADED_USERS_ROSTERBUILDER_SUCCESS',
  LOADING_USERS_IN_PROGRESS: 'ROSTERBUILDER_TIMELINE/LOADING_USERS_IN_PROGRESS',
  LOADING_USERS_FAILED: 'ROSTERBUILDER_TIMELINE/LOADING_USERS_FAILED',

  ASSIGN_USER_TO_PLACEHOLDER: 'ROSTERBUILDER_TIMELINE/ASSIGN_USER_TO_PLACEHOLDER',
  REMOVE_ASSIGNED_USER: 'ROSTERBUILDER_TIMELINE/REMOVE_ASSIGNED_USER',
  REORDER_ASSIGNED_USER: 'ROSTERBUILDER_TIMELINE/REORDER_ASSIGNED_USER',
  SWAP_USER_WITH_PLACEHOLDER: 'ROSTERBUILDER_TIMELINE/SWAP_USER_WITH_PLACEHOLDER',

  SAVE_ADDTOROSTER_SUCCESS: 'ROSTERBUILDER_TIMELINE/SAVE_ADDTOROSTER_SUCCESS',
  SAVE_ADDTOROSTER_FAILURE: 'ROSTERBUILDER_TIMELINE/SAVE_ADDTOROSTER_FAILURE',

  CYCLIC_ORDER_SHIFT_USERS: 'ROSTERBUILDER_TIMELINE/CYCLIC_ORDER_SHIFT_USERS'
};

export const SITE = {
  TOGGLE_MENU: 'SITE/TOGGLE_MENU'
};

export const API = {
  REQUEST_IN_FLIGHT: 'API/REQUEST_IN_FLIGHT',
  REQUEST_SUCCESS: 'API/REQUEST_SUCCESS',
  REQUEST_FAILED: 'API/REQUEST_FAILED',
  RESET: 'API/RESET',
  CLEAR_ERROR: 'API/CLEAR_ERROR',
  DIRTY: 'API/DIRTY'
};

export const OPTIMISER_STATUS = {
  SUMMARY_IN_FLIGHT: 'OPTIMISER_STATUS/SUMMARY_IN_FLIGHT',
  SUMMARY_SUCCESS: 'OPTIMISER_STATUS/SUMMARY_SUCCESS',
  SUMMARY_FAILURE: 'OPTIMISER_STATUS/SUMMARY_FAILURE',

  VIOLATIONS_IN_FLIGHT: 'OPTIMISER_STATUS/VIOLATIONS_IN_FLIGHT',
  VIOLATIONS_SUCCESS: 'OPTIMISER_STATUS/VIOLATIONS_SUCCESS',
  VIOLATIONS_FAILURE: 'OPTIMISER_STATUS/VIOLATIONS_FAILURE',

  SET_FILTERS: 'OPTIMISER_STATUS/SET_FILTERS',

  ATTEMPTS_IN_FLIGHT: 'OPTIMISER_STATUS/ATTEMPTS_IN_FLIGHT',
  ATTEMPTS_SUCCESS: 'OPTIMISER_STATUS/ATTEMPTS_SUCCESS',
  ATTEMPTS_FAILURE: 'OPTIMISER_STATUS/ATTEMPTS_FAILURE',

  WRITEBACK_IN_FLIGHT: 'OPTIMISER_STATUS/WRITEBACK_IN_FLIGHT',
  WRITEBACK_SUCCESS: 'OPTIMISER_STATUS/WRITEBACK_SUCCESS',
  WRITEBACK_FAILURE: 'OPTIMISER_STATUS/WRITEBACK_FAILURE'
};

export const VALIDATION_BLOCK = {
  SHOW: 'VALIDATION_BLOCK/SHOW',
  DISMISS: 'VALIDATION_BLOCK/DISMISS'
};

export const SOLACE_HEALTH = {
  LOAD_IN_FLIGHT: 'SOLACE_HEALTH/LOAD_IN_FLIGHT',
  LOAD_SUCCESS: 'SOLACE_HEALTH/LOAD_SUCCESS',
  LOAD_FAILURE: 'SOLACE_HEALTH/LOAD_FAILURE'
};

export const OPTIMISER_RUN_STATUS = {
  LOAD_IN_FLIGHT: 'OPTIMISER_RUN_STATUS/LOAD_IN_FLIGHT',
  LOAD_SUCCESS: 'OPTIMISER_RUN_STATUS/LOAD_SUCCESS',
  LOAD_FAILURE: 'OPTIMISER_RUN_STATUS/LOAD_FAILURE',
  OBSERVE_FINISHED_RUN: 'OPTIMISER_RUN_STATUS/OBSERVE_FINISHED_RUN',
  ACKNOWLEDGE_RUN: 'OPTIMISER_RUN_STATUS/ACKNOWLEDGE_RUN',
  HISTORY_IN_FLIGHT: 'OPTIMISER_RUN_STATUS/HISTORY_IN_FLIGHT',
  HISTORY_SUCCESS: 'OPTIMISER_RUN_STATUS/HISTORY_SUCCESS',
  HISTORY_FAILURE: 'OPTIMISER_RUN_STATUS/HISTORY_FAILURE'
};
